import { gql } from "@apollo/client";

export const QUERY_GET_BARRIER_TYPES = gql`
  query MUTATION_GET_BARRIER_TYPES($processId: Int) {
    typeBarrier(where: { processId: { _eq: $processId } }) {
      description
      id
      name
      processId
    }
  }
`;

export const QUERY_GET_BARRIER_SUBTYPES = gql`
  query MUTATION_GET_BARRIER_SUBTYPES($typeBarrierId: uuid) {
    subTypeBarrier(where: { typeBarrierId: { _eq: $typeBarrierId } }) {
      description
      id
      name
      typeBarrierId
      typeBarrier {
        description
        id
        name
        processId
      }
    }
  }
`;

export const QUERY_GET_USER_TO_BARRIERS_FILTERS = gql`
  query QUERY_GET_USER_TO_BARRIERS_FILTERS(
    $where: userToBarrier_bool_exp
    $limit: Int
    $offset: Int
  ) {
    userToBarrier(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
    ) {
      barrierStatus
      created_at
      description
      doctorId
      estimatedSolutionDate
      id
      processId
      severity
      solutionDate
      subTypeBarrierId
      updated_at
      userId
      userToProcessId
      barrierStatusValue {
        name
        value
        description
      }
      subTypeBarrier {
        description
        id
        name
        typeBarrier {
          description
          id
          name
          processId
        }
      }
      user {
        documentNumber
        documentType
        id
        lastname
        name
        picture
        email
      }
    }
  }
`;

export const MUTATION_INSERT_USER_TO_BARRIER = gql`
  mutation MUTATION_INSERT_USER_TO_BARRIER(
    $objects: [userToBarrier_insert_input!]!
  ) {
    insert_userToBarrier(objects: $objects) {
      returning {
        barrierStatus
        created_at
        description
        doctorId
        estimatedSolutionDate
        id
        processId
        severity
        solutionDate
        subTypeBarrierId
        updated_at
        userId
      }
    }
  }
`;

export const QUERY_GET_BARRIER_BY_ID = gql`
  query QUERY_GET_BARRIER_BY_ID($_eq: uuid) {
    userToBarrier(where: {id: {_eq: $_eq}}) {
      barrierStatus
      created_at
      description
      barrierStatusValue {
        description
        name
        value
      }
      doctorId
      estimatedSolutionDate
      id
      processId
      severity
      solutionDate
      subTypeBarrierId
      updated_at
      userId
      userToProcessId
      subTypeBarrier {
        description
        id
        name
        typeBarrier {
          description
          id
          name
        }
      }
      user {
        documentNumber
        documentType
        id
        lastname
        name
        picture
        email
      }
    }
  }
`;
